import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'
import _ from 'lodash'
import { NavBar } from '..'

const propTypes = {
  blogTitle: PropTypes.string.isRequired,
  coverImgLink: PropTypes.string.isRequired,
  blogTags: PropTypes.array.isRequired
}

const BlogPageHeader = (props) => {
  const { blogTitle, coverImgLink, blogTags } = props

  return (
    <styles.Container backgroundImg={coverImgLink}>
      <NavBar background="transparent" textColor="white" />
      <styles.TitleContainer>
        <styles.TextWrapper>
          <styles.CenteredHeader>
            {blogTitle}
          </styles.CenteredHeader>
          <styles.TagRow>
            {_.map(blogTags, (tag, i) => {
              return (
                <styles.Tag key={i}>{`#${tag}`}</styles.Tag>
              )
            })}
          </styles.TagRow>
        </styles.TextWrapper>
      </styles.TitleContainer>
    </styles.Container>
  )
}

BlogPageHeader.propTypes = propTypes

export default BlogPageHeader
